// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/pageRoutes.test.ts
// eslint-disable-next-line import/named
import { createRoute } from "@tanstack/react-router";

import { askV2AuthLayoutRoute } from "./authLayout";

import { parseLauncherSearch } from "../../utils/askPunttLauncherSearch";
import { AskV2ChatsPage } from "../pages/AskV2ChatsPage";

export const askV2ChatsRoute = createRoute({
  getParentRoute: () => askV2AuthLayoutRoute,
  path: "ask-puntt/chats",
  validateSearch(search: Record<string, unknown>) {
    return parseLauncherSearch(search);
  },
  component: AskV2ChatsPage,
});
